import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService } from '../../service/authentication.service';
import { CommonService } from "../../service/common.service";
import { EventEmitterService } from '../../service/event-emitter.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Statocommessa } from '../../models/statocommessa';
import { Commessa } from '../../models/commessa';

@Component({
  selector: 'app-orfrihomepage',
  templateUrl: './orfrihomepage.component.html',
  styleUrls: ['./orfrihomepage.component.css']
})
export class OrfrihomepageComponent implements OnInit {
  numAssegnate: number;
  valoristato: [{codice: number, value: number }];
  staticommessa: Statocommessa[];
  commesse: Commessa[];
  constructor(private commonService: CommonService,
    private eventEmitterService: EventEmitterService,
    private router: Router) { }

  ngOnInit() {
    this.numAssegnate=30;
    this.valoristato=[{codice: 0, value: 0 }];
    this.commonService.selectedStatocommessa=undefined;
    this.commonService.getAllStaticommessa().subscribe((res) => {
        this.staticommessa = res;
        this.staticommessa.forEach(s => {
            this.valoristato.push({codice:s.Codice, value: 0 });
        });
         this.commonService.getAllCommesse().subscribe((res2) => {
           this.commesse=res2;
           this.commesse.forEach(c => {
             let cod=c.Statocommessa.Codice;
             if (this.valoristato[cod]!=undefined){
               let val=this.valoristato[cod].value;
               this.valoristato[cod].value=val+1;
             }
           });
      });
    });
  }
  dettaglio(stato:Statocommessa){
    this.commonService.selectedStatocommessa=stato;
    this.router.navigate(['commesse']);
  }

  getStatusColor(stato:string) {
    switch (stato) {
      case 'Preventivo':
        return 'black';
      case 'Assegnata':
        return 'orange';
      case 'In Lavorazione':
        return 'blue';
      case 'Sospesa':
        return 'red';
      case 'Conclusa':
        return 'green';
    }
    return 'black';
  }

}
